import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  saveClient,
  deleteClient,
  setEditMode,
} from '../../actions/advisor';
import s from './EditClientForm.css';

class EditClientForm extends PureComponent {

  constructor(props) {
    super(props);
    const newClient = Object.assign({}, this.props.client);
    this.state = {
      client: newClient,
    };
  }

  // update the value to state for form text fields
  editClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
     } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // save client with current saved state values
  saveClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    if(client.firstName !== '' && client.lastName !== '' && client.email !== '') {
      this.props.saveClient(client).then(() => {
        this.props.setEditMode('');
      });
    }
  }

  // delete the client
  deleteClient = (event) => {
    event.preventDefault();
    if(this.state.deleteButton === 'DELETE') {
      this.setState(Object.assign({}, this.state, {
        deleteButton: 'CONFIRM',
      }));
    } else {
      this.props.deleteClient(this.state.client);
      this.setState(Object.assign({}, this.state, {
        deleteButton: '...',
      }));
    }
  }

  clearEditMode = (event) => {
    event.preventDefault();
    this.props.setEditMode('');
  }

  render() {
    const {
      client,
    } = this.state;
    return (
      <div className={s.content}>
        <form>
          <div className={'form-group'}>
              <label htmlFor="firstName" className={s.formLabel}>First Name</label>
              <input
                name="firstName"
                value={client.firstName}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'} placeholder="First Name"
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="lastName" className={s.formLabel}>Last Name</label>
              <input
                name="lastName"
                value={client.lastName}
                onChange={this.editClientFormChange}
                type="text"
                className={'form-control'}
                placeholder="Last Name"
              />
          </div>
          <div className={'form-group'}>
              <label htmlFor="email" className={s.formLabel}>Email</label>
              <input
                name="email"
                value={client.email}
                onChange={this.editClientFormChange}
                type="email"
                className={'form-control'} placeholder="Email"
              />
          </div>
          <div className={'row'} style={{marginTop:'30px'}}>
            <div className='col-md-6'>
              <button
                onClick={this.saveClient}
                className={s.saveButton}
              >SAVE</button>
            </div>
            <div className='col-md-6'>
              <button
                onClick={this.clearEditMode}
                className={s.cancelButton}
              >CANCEL</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveClient,
  deleteClient,
  setEditMode,
})(EditClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditClientForm.js